import {SubMenu} from './sub-menu';

export class Menu {
  public route: string;
  public menuText: string;
  public icon: string;
  public cssClass: string;
  public subMenuList: SubMenu[] = [];

  constructor(route: string, menuText: string, icon: string, cssClass: string) {
    this.route = route;
    this.menuText = menuText;
    this.icon = icon;
    this.cssClass = cssClass;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/common-layout/menu.ts